import "./FormKycCli.scss";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button, Col, Form, Input, Row, Spin, DatePicker, Select, Radio, Table, Icon, notification, Checkbox, InputNumber, Upload, message, List, Modal } from "antd";
import useFormsHooks from "../../../../../InterestConflicts/forms/hooks/useFormsHooks";
import { FormLayout } from "../../../../../../layouts";
import { withRouter } from "../../../../../../helpers/withRouter";
import apiConfig from '../../../../../../config/api'
import { getFormPromise, getParamsPromise, saveFormOnbPromise, sendFormPromise, signCDIFormPromise, sendFileFormPromise } from "../../../../promises";
import { getCountriesCodePromise } from '../../../../promises';
import moment from "moment";
import Logo from '../../../../../../layouts/commonComponent/components/Logo/Logo'
import { validateRucHelper, validateRucEntityHelper, camelizerHelper } from "../../../../../../helpers";
import HelloSign from 'hellosign-embedded';
import { getRegionComunaPromise, getSIIActivitiesPromise } from "../../../../../../promises";
import { propositoRelOptions, peru } from "../../../parauco/assets";

const FormKyc = ({ form, match }) => {
  const { t } = useTranslation();
  const { getFieldDecorator, validateFields, getFieldsError, setFieldsValue } = form;
  const [isValidate, setIsValidate] = useState(true);
  const [isLoading, setIsloading] = useState(false);
  const [paises, setPaises] = useState(null);
  const [date, setDate] = useState(0);
  const [user, setUser] = useState({});
  const [apiForm, setApiForm] = useState(null);
  const [colLogo, setColLogo] = useState(4);
  const [format, setFormat] = useState("html");
  const [validarRegistros, setValidarRegistros] = useState(false);
  const [signed, setSigned] = useState(false);
  const [openSigner, setOpenSigner] = useState(false);
  const hasSign = false
  const [clientName, setClientName] = useState("");
  const [sentErrors, setSentErrors] = useState(0);
  const [tmpFilesList, setTmpFilesList] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [userFileName, setUserFileName] = useState("");
  const [SIIActivities, setSIIActivities] = useState([]);
  const [regionesPais, setRegionesPais] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [distritos, setDistritos] = useState([]);

  let registersStop = {};

  const radioStyle = {
      display: 'block',
      height: '22px',
      lineHeight: '22px',
    };

  const handleListDeleted= (index) =>{
    setFileNames(oldFileNames => {
      const newFileNames = oldFileNames.slice();
      newFileNames.splice(index, 1)

      return newFileNames
    })

    setTmpFilesList(oldTmpFilesList => {
      const newTmpFilesList = oldTmpFilesList.slice();
      newTmpFilesList.splice(index, 1)

      return newTmpFilesList
    })
  }

  const propsUpload = {
    accept: ".pdf, .png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx",
    onRemove: file => {
      const index = tmpFilesList.indexOf(file);
      handleListDeleted(index);
    },
    beforeUpload: file => {
      validateFields([attch.attchFileName.id]).then((error, values) => {
        const validFiles = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg' || file.name.endsWith('.doc') || file.name.endsWith('.docx') || file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
        if (!validFiles) {
          message.error('Formato no permitido.');
        }else{
          const validSize = file.size / 1024 / 1024 < 2;
          if (!validSize) {
            message.error('Tamaño máximo 2MB!');
          }else{
            setTmpFilesList(oldTmpFilesList => [...oldTmpFilesList, file]);
            setFileNames(oldFileNames => [...oldFileNames, attch.attchFileName.val]);
          }
          setFieldsValue({[attch.attchFileName.id]: null})
          handleOnChangeField(attch.attchFileName.id, "")
        }
      })
      return false
    },
    multiple: false,
    showUploadList: false
  }

  const handleOnClear = (section)=>{
    switch (section) {
      case 'prodAct':
        setProdAct({...prodActIS})
        setFieldsValue(Object.keys(prodActIS).reduce((acu,key)=>{
          return {...acu,[key]:undefined}
        },{}))
        break;
      case 'activityEsp':
      setActivityEsp({...activityEspIS})
      setFieldsValue(Object.keys(activityEspIS).reduce((acu,key)=>{
        return {...acu,[key]:undefined}
      },{}))
      break;
      case 'pepPublicObj':
        setPepPublicObj({...pepPublicObjIS})
        setFieldsValue(Object.keys(pepPublicObjIS).reduce((acu,key)=>{
          return {...acu,[key]:undefined}
        },{}))
        break;
      case 'pepFamilyObj':
        setPepFamilyObj({...pepFamilyObjIS})
        setFieldsValue(Object.keys(pepFamilyObjIS).reduce((acu,key)=>{
          return {...acu,[key]:undefined}
        },{}))
        break;
      case 'accionistaObj':
        setAccionistaObj({...accionistaObjIS})
        setFieldsValue(Object.keys(accionistaObjIS).reduce((acu,key)=>{
          return {...acu,[key]:undefined}
        },{}))
        break;
      default:
        break;
    }
  }

  const basicInfoIS= {
    basicInfoName: { key: "name", val: "", title: "Nombre", maxLength:200, id: "basicInfoName", required:true, type: 'input', readOnly:true, section: 'basicInfo', disabled: true },
    basicInfoTipoDoc: { key:"tipoDocumento", title:"Tipo del documento", maxLength:200, id:'basicInfoTipoDoc',readOnly:true, type: 'select', section: 'basicInfo' },
    basicInfoNroDoc: { key: "nroDocumento", val: "", title: "Nro. de Identificación", maxLength:200, id: "basicInfoNroDoc", required:true, readOnly:true, type: 'input', section: 'basicInfo', disabled: true },
    basicInfoTipoEmpresa: { key:"tipoEmpresa",title:"Tipo de empresa", maxLength:200, id:'basicInfoTipoEmpresa',readOnly:true, type: 'select', section: 'additionalInfo' },
    basicInfoNombreFantasia: { key:"nombreFantasia",title:"Nombre de Fantasía:", maxLength:200, id:'basicInfoNombreFantasia',readOnly:true, type: 'input', section: 'additionalInfo' },
    basicInfoNationality: { key:"nationality", title:"Nacionalidad", size:"small", mFxLength:200, id:'basicInfoNationality',readOnly:true, type: 'select', section: 'basicInfo' },
    basicInfoPaisConst: { key:"paisConst", title:"País de Constitución", mFxLength:200, id:'basicInfoPaisConst',readOnly:true, type: 'select', section: 'basicInfo' },
    basicInfoPropositoRel: { key:"propositoRel",val: undefined, title:"Propósito de la Relación", maxLength:200, id:'basicInfoPropositoRel',readOnly:true, type:'select', section: 'basicInfo' },
    basicInfoPropositoRelOtro: { key:"propositoRelOtro", title:"Describa Otro", maxLength:200, id:'basicInfoPropositoRelOtro',readOnly:true, type:'input' },
    basicInfoResindenciaPais: {  key:"residenciaPais", title:"País de residencia", maxLength:200, id:'basicInfoResindenciaPais',readOnly:true, type:'select', section: 'basicInfo' },
    basicInfoOcupacion: { key:"oficio", title: "Ocupación u oficio", maxLength:200, id:'basicInfoOcupacion',readOnly:true, type: 'select', section: 'additionalInfo' },
    basicInfoOcupacionOtro: { key:"otroOficio",val: "", title:"Especifique otro oficio" ,maxLength:200, id:'basicInfoOcupacionOtro',readOnly:true, type: 'input', section: 'additionalInfo' },
    basicInfoContactName: { key:"contactName",val: "", title:"Nombre y Apellidos", maxLength:200, id:'basicInfoContactName',readOnly:true, section:'contacto' },
    basicInfoCargo: { key: "infoCargo", val:"",title:"Cargo", maxLength:200, id:'basicInfoCargo', readOnly:true, section:'contacto' },
    basicInfoResindencia: { key:"residencia",val: undefined, title:"¿Tiene residencia permanente en otro país?", maxLength:200, id:'basicInfoResindencia',readOnly:true, type:'select', section: 'additionalInfo' },
    basicInfoMail: { key:"mail",val: "", title:"Correo Electrónico" ,maxLength:200, id:'basicInfoMail',readOnly:true, section:'contacto' },
    basicInfoDir: { key:"direccion",val: "", title: "Dirección" ,maxLength:60, id:'basicInfoDir',readOnly:true, section:'domicilio' },
    basicInfoDepartamento: { key:"departamento",val: "", title: "Departamento", id:"basicInfoDepartamento", readOnly: true, section:'domicilio', type: 'select', required: true},
    basicInfoProvincia: { key:"provincia",val: "", title: "Provincia", id:"basicInfoProvincia", readOnly: true, section:'domicilio', type: 'select', required: true},
    basicInfoDistrito: { key:"distrito",val: "", title: "Distrito", id:"basicInfoDistrito", readOnly: true, section:'domicilio', type: 'select', required: true},
    basicInfoPais: { key:"pais", title: "País", id:"basicInfoPais", readOnly: true, type: 'select', section:'domicilio' },
    basicInfoCodigoPais: { key:"codigoPais", id:"basicInfoCodigoPais", readOnly: true, section:'domicilio' },
    basicInfoCodigoDepartamento: { key:"codigoDepartamento", id:"basicInfoCodigoDepartamento", readOnly: true, section:'domicilio' },
    basicInfoCodigoProvincia: { key:"codigoProvincia", id:"basicInfoCodigoProvincia", readOnly: true, section:'domicilio' },
    basicInfoCodigoDistrito: { key:"codigoDistrito", id:"basicInfoCodigoDistrito", readOnly: true, section:'domicilio' },
    basicInfoTel: { key:"tel",val: "", title: "Teléfono Fijo", id:"basicInfoTel", readOnly: true, required: false, type: 'input', section:'contacto' },
    basicInfoCel: { key:"cel",val: "", title: "Teléfono Celular", id:"basicInfoCel", type: 'input', section:'contacto', required: true },
    basicInfoMtrz: { key:"matriz", title: "Tiene Casa Matriz?", id:"basicInfoMtrz", type: 'select', section: 'additionalInfo' },
    basicInfoMtrzName: { key:"nombreMatriz",val: "", title: "Razón Social", id:"basicInfoMtrzName", readOnly: true, section: 'casaMatriz' },
    basicInfoMtrzDir: { key:"direccionMatriz",val: "", title: "Dirección", id:"basicInfoMtrzDir", readOnly: true, section: 'casaMatriz' },
    basicInfoMtrzPais: { key:"paisMatriz", title: "País", id:"basicInfoMtrzPais", readOnly: true, type: 'select', section: 'casaMatriz' },
    basicInfoMtrzCity: { key:"ciudadMatriz",val: "", title: "Ciudad", id:"basicInfoMtrzCity", readOnly: true, section: 'casaMatriz' },
    basicInfoNomFacturacion: { key:"nombreFacturacion",val: "", title: "Nombre y Apellidos", maxLength:200, id:"basicInfoNomFacturacion", section: 'facturacion' },
    basicInfoMailFacturacion: { key:"mailFacturacion",val: "", title: "Correo electrónico", maxLength:200, id:"basicInfoMailFacturacion", readOnly: true, section: 'facturacion' },
    basicInfoCelFacturacion: { key:"celFacturacion",val: "", title: "Teléfono Celular", id:"basicInfoCelFacturacion", readOnly: true, required: true, section: 'facturacion' },
    basicInfoTelFacturacion: { key:"telFacturacion",val: "", title: "Teléfono Fijo", id:"basicInfoTelFacturacion",required: false, section: 'facturacion' },
    basicInfoCargoFacturacion: { key:"cargoFacturacion",val: "", title: "Cargo", maxLength:200, id:"basicInfoCargoFacturacion", readOnly: true, section: 'facturacion' },
  };
  const [basicInformation, setBasicInformation]=useState(basicInfoIS);


  const infoActEcoIS= {
    infoActEcoRecords: { key: "actRecords", val: [], id: "infoActEcoRecords" },
    infoActEcoEspRecords: { key: "actEspRecords", val: [], id: "infoActEcoEspRecords"},
    infoActEcoInitAct: { key: "fecInicioAct", val: null, title: "Fecha de Inicio de Actividades", id: "infoActEcoInitAct", type:'date', required:true, readOnly:true },
    infoActEcoExperienciaMercado: { key:"experienciaMercado",val: "", title:"Experiencia en el mercado (meses)", maxLength:200, id:'infoActEcoExperienciaMercado',readOnly:false, disabled: true },
    infoActEcoPais: { key:"pais",val: "", title:"País", maxLength:200, id:'infoActEcoPais',readOnly:true, type: 'select' },
    infoActEcoCustomActivities: { key:"customActivities",val: undefined, title:"Actividad comercial principal a desarrollar en el local", maxLength:200, id:'infoActEcoCustomActivities',readOnly:true, type: 'select' }
  };
  const [infoActEco, setInfoActEco]=useState(infoActEcoIS);
  const prodActIS= {
    prodActDescripcion: { key: "linea", val: "", title: "Actividad Económica según códigos del CIIU (Indicar las 3 principales)", maxLength:200, id: "prodActDescripcion", required:true, readOnly:true, type: 'select'},
    prodActOtras: { key: "otras", val: "", title: "Ingrese la actividad realizada", maxLength:200, id: "prodActOtras", required:true, type: 'input'},
  };
  const [prodAct, setProdAct]=useState(prodActIS);

  const accionistasIS= {
    accionistasIsAccionista: { key: "isAccionista", val: undefined, title: "", id: "accionistasIsAccionista", required: true},
    accionistasAccionistaRecords: { key: "accionistaRecords", val:[], id: "accionistasAccionistaRecords"},
  };
  const [accionistas, setAccionistas]=useState(accionistasIS);

  const accionistaObjIS={
    accionistaObjTipoPersona: { key: "tipoPersona", title: "Tipo de persona", maxLength:50, id: "accionistaObjTipoPersona", required: true, type: 'select', typeEntity: ['PJ']},
    accionistaObjName: { key: "name", title: "Nombres y Apellidos / Razón Social", maxLength:100, id: "accionistaObjName", required: true, typeEntity: ['PJ']},
    accionistaObjTipoId: { key: "tipoId", title: "Tipo de documento", maxLength:50, id: "accionistaObjTipoId", required: true, type: 'select', typeEntity: ['PJ']},
    accionistaObjNroIdentificacion: { key: "nroIdentificacion", title: "Nro. de identificación", maxLength:50, id: "accionistaObjNroIdentificacion", required: true, type: 'input', typeEntity: ['PJ']},
    accionistaObjNacionalidad: { key: "nacionalidad", title: "Nacionalidad", maxLength:200, id: "accionistaObjNacionalidad", required: true, typeEntity: ['PJ'], type: 'select'},
    accionistaObjParticipacion: { key: "participacion", title: "Participación (en %)", id: "accionistaObjParticipacion", required: true, typeEntity: ['PJ'], type:'number', isPercentage: true, max: 100, min: 0},
  };
  const [accionistaObj, setAccionistaObj]=useState(accionistaObjIS);

  const activityEspIS= {
    activityEspAct: { key: "activity", title: "Actividad", maxLength:200, id: "activityEspAct", required:true , readOnly:true, type: 'select'},
    activityEspPais: { key: "actPais", title: "País", maxLength:200, id: "activityEspPais", required:true, readOnly:true, type: 'select'},
  }
  const [activityEsp, setActivityEsp]=useState(activityEspIS);

  const infoPepIS= {
    infoPepIsPublic: { key: "isPublic", val: undefined, title: "", maxLength:200, id: "infoPepIsPublic", required: true},
    infoPepHasFamily: { key: "hasFamily", val: "", title: "", maxLength:200, id: "infoPepHasFamily", required: true},
    infoPepPublicRecords: { key: "publicRecords", val: [], id: "infoPepPublicRecords"},
    infoPepFamilyRecords: { key: "familyRecords", val: [], id: "infoPepFamilyRecords"},
  };
  const [infoPep, setInfoPep]=useState(infoPepIS);

  const  pepPublicObjIS={
    pepPublicCargo: { key: "cargo", val: "", title: "Cargo", maxLength:200, id: "pepPublicCargo", required: true, typeEntity: ['PN']},
    pepPublicGrupo: { key: "grupo", title: "Grupo relacionado", maxLength:200, id: "pepPublicGrupo", required: true, type: 'select', typeEntity: ['PJ']},
    pepPublicName: { key: "name", val: "", title: "Nombre Completo", maxLength:200, id: "pepPublicName", required: true, typeEntity: ['PJ']},
    pepPublicTipoDoc: { key: "tipoId", title: "Tipo de documento", maxLength:200, id: "pepPublicTipoDoc", required: true, type: 'select', typeEntity: ['PJ']},
    pepPublicNroId: { key: "nroIdentificacion", val: "", title: "Nro. de identificación", maxLength:200, id: "pepPublicNroId", required: true, type: 'input', typeEntity: ['PJ']},
    pepPublicOrgPublic: { key: "orgPublic", val: "", title: "Organismo Público", maxLength:200, id: "pepPublicOrgPublic", required: true, typeEntity: ['PJ','PN']},
    pepPublicPais: { key: "pais", title: "País", maxLength:200, id: "pepPublicPais", required: true, type: 'select', typeEntity: ['PJ','PN']},
    pepPublicCargoPj: { key: "cargo", val: "", title: "Cargo", maxLength:200, id: "pepPublicCargoPj", required: true, typeEntity: ['PJ']},
    pepPublicFecTermino: { key: "fecTermino", val: null, title: "Fecha de término", maxLength:200, id: "pepPublicFecTermino", required: false, type: 'date', typeEntity: ['PJ','PN']},
  }
  const [pepPublicObj, setPepPublicObj]=useState(pepPublicObjIS);

  const  pepFamilyObjIS={
    pepFamilyParentesco: { key: "parentesco", title: "Tipo de Parentesco", maxLength:200, id: "pepFamilyParentesco", required: true, type: 'select', typeEntity: ['PN']},
    titlePersona: { key: 'titlePersona', title: "Datos de la persona relacionada", type: 'subtitle', typeEntity: ['PJ']},
    pepFamilyGrupo: { key: "grupo", title: "Grupo de la persona relacionada", maxLength:200, id: "pepFamilyGrupo", required: true, type: 'select', typeEntity: ['PJ']},
    pepFamilyName: { key: "name", title: "Nombre del Familiar", maxLength:200, id: "pepFamilyName", required: true, type: 'input', typeEntity: ['PJ','PN']},
    pepFamilyTipoDoc: { key: "tipoDoc", title: "Tipo de documento", maxLength:200, id: "pepFamilyTipoDoc", required: true, type: 'select', typeEntity: ['PJ','PN']},
    pepFamilyNroId: { key: "nroId", title: "Nro. de identicación", maxLength:200, id: "pepFamilyNroId", required: true, type: 'input', typeEntity: ['PJ','PN']},
    pepFamilyCargo: { key: "cargo", val: "", title: "Cargo del PEP", maxLength:200, id: "pepFamilyCargo", required: true, typeEntity: ['PN']},
    titlePariente: { key: 'titlePariente', title: "Datos del pariente que posee el cargo de PEP", type: 'subtitle', typeEntity: ['PJ']},
    pepFamilyParentescoPariente: { key: "parentesco", title: "Tipo de Parentesco", maxLength:200, id: "pepFamilyParentescoPariente", required: true, type: 'select', typeEntity: ['PJ']},
    pepFamilyNamePariente: { key: "nombrePariente", title: "Nombre Completo", maxLength:200, id: "pepFamilyNamePariente", required: true, type: 'input', typeEntity: ['PJ']},
    pepFamilyTipoDocPariente: { key: "tipoDocPariente", title: "Tipo de documento", maxLength:200, id: "pepFamilyTipoDocPariente", required: true, type: 'select', typeEntity: ['PJ']},
    pepFamilyNroIdPariente: { key: "nroIdPariente", title: "Nro. de identificación", maxLength:200, id: "pepFamilyNroIdPariente", required: true, type: 'input', typeEntity: ['PJ']},
    pepFamilyOrgPublic: { key: "orgPublic", val: "", title: "Organismo Público", maxLength:200, id: "pepFamilyOrgPublic", required: true, typeEntity: ['PJ','PN']},
    pepFamilyPais: { key: "pais", title: "País", maxLength:200, id: "pepFamilyPais", required: true, type: 'select', typeEntity: ['PJ','PN']},
    pepFamilyCargoPariente: { key: "cargo", val: "", title: "Cargo del PEP", maxLength:200, id: "pepFamilyCargoPariente", required: true, typeEntity: ['PJ']},
    pepFamilyFecTermino: { key: "fecTermino", val: null, title: "Fecha de término", maxLength:200, id: "pepFamilyFecTermino", required: false, type: 'date', typeEntity: ['PJ','PN']},
  }
  const [pepFamilyObj, setPepFamilyObj]=useState(pepFamilyObjIS);

  const attchIs={
    attchFileName: {key: "fileName", val: "", id: "attchFileName", maxLength: 200, required: true},
  }
  const [attch, setAttch] = useState(attchIs)
 // END INIT OBJ

  const validateLengthFieldWithInnerLength = (section)=>{
    return {
      max: section.maxLength,
      message: "Debe tener un máximo de "+ section.maxLength  + " caracteres"
    }
  }

  const handleReadOnly = (field,readOnly,sectionId=null)=>{
    if (sectionId===null){
      const key = Object.entries(basicInformation).filter(([key,value])=>{
        return value.id === field
      })[0][0]
      setBasicInformation({...basicInformation,[key]:{...basicInformation[key],readOnly:readOnly}})
    }else{
      settingStateObj(sectionId,readOnly)
    }
  }

  const settingStateObj=(sectionId,readOnly)=>{
    const [stateObject,stateObjectSetter] = customState(sectionId)
    stateObjectSetter({...stateObject,[sectionId]:{...stateObject[sectionId],readOnly:readOnly}})
  }

  const customState=(sectionId)=>{
    if (sectionId.startsWith('basicInfo')) {
      return([basicInformation,setBasicInformation])
    }else if (sectionId.startsWith('infoActEco')) {
      return([infoActEco,setInfoActEco])
    }else if (sectionId.startsWith('infoPep')) {
      return([infoPep,setInfoPep])
    }else if (sectionId.startsWith('prodAct')) {
      return([prodAct,setProdAct])
    }else if (sectionId.startsWith('activityEsp')) {
      return([activityEsp,setActivityEsp])
    }else if (sectionId.startsWith('pepPublic')) {
      return([pepPublicObj,setPepPublicObj])
    }else if (sectionId.startsWith('pepFamily')) {
      return([pepFamilyObj,setPepFamilyObj])
    }else if (sectionId.startsWith('attch')){
      return ([attch, setAttch])
    }else if (sectionId.startsWith('accionistas')) {
      return([accionistas, setAccionistas])
    }else if (sectionId.startsWith('accionistaObj')) {
      return([accionistaObj, setAccionistaObj])
    }
  }

  const entriesToObj = (obj) => {
    const objAttr = {}
    Object.entries(obj).map(([key, value]) => {
      if(value.section) {
        if(!objAttr[value.section]) objAttr[value.section] = {}
        objAttr[value.section][value.key] = value.val
      }else {
        objAttr[value.key] = value.val
      }
    })
    return objAttr
  }

  const handlerOnChangeObjAttr = async (sectionId, value, formObj) => {
    handleOnChangeField(sectionId, value)
    const [stateObject,stateObjectSetter] = customState(sectionId)
    stateObject[sectionId].val = value

    const basicInfo = entriesToObj(basicInformation)
    const iEco = entriesToObj(infoActEco)
    const iPep = entriesToObj(infoPep)
    const acc = entriesToObj(accionistas)

    if(!formObj) formObj = apiForm
    const json = { basicInformation: basicInfo, infoActEco: iEco, infoPep: iPep, accionistas: acc }
    let formToUpdate = { ...formObj, json };
    let ret = await saveFormOnbPromiseLocal(formToUpdate);
    if(!ret.success) {
    //  setFieldsValue({[field]: ret.form[field]})
    }
  }

  const handleOnChangeField = (sectionId, value) => {
    const [stateObject, stateObjectSetter] = customState(sectionId)
    stateObjectSetter({ ...stateObject, [sectionId]: { ...stateObject[sectionId], val: value }});
  };

  const objToVariable = (variable, obj) => {
    let varAttr = { ...variable }
    for(var key in obj) {
      for(var prop in variable) {
        if(variable[prop].key === key && varAttr[prop]) {
          varAttr[prop].val = obj[key]
        }else if(typeof obj[key] === "object" && variable[prop].section === key) {
          for(var attr in obj[key]) {
            if(variable[prop].key === attr && varAttr[prop]) {
              varAttr[prop].val = obj[key][attr]
            }
          }
        }
      }
    }
    return varAttr
  }

  const initVariablesFromObject = (obj) => {
    if(obj.json) {
      if(obj.json.basicInformation) {
        if(obj.json.basicInformation.domicilio?.codigoPais === 'PE') {
          getRegionComunaPromise(obj.json.basicInformation.domicilio.codigoPais).then((regiones) => {
            setRegionesPais(regiones)
            if(regiones) {
              const region = regiones.filter(r => r.code === obj.json.basicInformation.domicilio?.codigoDepartamento)
              if(region?.length === 1) {
                const provs = region[0].provincias
                setProvincias(provs)
                const provincia = provs.filter(r => r.code === obj.json.basicInformation.domicilio?.codigoProvincia)
                if(provincia?.length === 1) {
                  setDistritos(provincia[0].comunas)
                }
              }
            }
          })
        }
        let basicInfo = objToVariable(basicInformation, obj.json.basicInformation)
        setBasicInformation(basicInfo)
      }
      if(obj.json.infoActEco) {
        let iEco = objToVariable(infoActEco, obj.json.infoActEco)
        setInfoActEco(iEco)
      }
      if(obj.json.infoPep) {
        let iPep = objToVariable(infoPep, obj.json.infoPep)
        setInfoPep(iPep)
      }
      if(obj.json.accionistas) {
        let acc = objToVariable(accionistas, obj.json.accionistas)
        setAccionistas(acc)
      }
    }
  }

  const { toDescriptionsPdf } = useFormsHooks({
    format,
    form,
    match,
    apiForm,
    setApiForm,
    handlerOnChangeObjAttr,
    initVariablesFromObject,
  });

  useEffect(() => {
    if (match.params.view === "pdf") {
      setColLogo(5);
      setFormat("pdf");
    }
    setIsloading(true);
    getCountriesCodePromise().then((response) => {
      setPaises(response)
    })
    getFormPromise(match.params.id).then((response) => {
      if (
          response.data !== null &&
          response.data !== "" &&
          response.data.status !== undefined
      ) {
        if (response.data.recipient.record.type === 'Entity'){
          response.data["typeSol"] = 'PJ'
        }else{
          response.data["typeSol"] = 'PN'
        }
        setApiForm(response.data);
        initVariablesFromObject(response.data, response.data.recipient.record)
        setUser(response.data.recipient.request.createUser);
        setClientName(response.data.recipient.request.createUser.cliente.name);
        getParamsPromise(
          response.data.recipient.request.createUser.cliente.id
        ).then((response) => {
          //setParams(response.data);
        });

        if(response.data.status === "SENT") {
          setDate(moment(response.data.receiveDate).format("DD-MM-YYYY"));
        }else {
          setDate(moment().format("DD-MM-YYYY"));
        }
      }
      setIsloading(false);
    });

    getSIIActivitiesPromise("PER").then((response) => {
      setSIIActivities(response)
    })
  }, []);

  const saveFormOnbPromiseLocal = async (form) => {
    let response = await saveFormOnbPromise(form);
    if(response.code !== 'OK' && response.form !== undefined && response.form !== null) {
      setApiForm(response.form)
      initVariablesFromObject(response.form)

      notification["error"]({
        message: t("messages.aml.notifications.anErrorOcurred"),
      });

      return { success: false, form: response.form}
    }else {
      setApiForm(form)
      return { success: true }
    }
  }

  const handleOnChangeRadioButton = async (field, value) => {
    let formToUpdate = { ...apiForm, [field]: value };
    let ret = await saveFormOnbPromiseLocal(formToUpdate);
    if(!ret.success) {
      setFieldsValue({[field]: ret.form[field]})
    }else{
      if (field === 'typeSol') {
        if (value === 'PJ'){
          handlerOnChangeObjAttr('basicInfoTipoDoc', 'RUC', formToUpdate)
        }else{
          handlerOnChangeObjAttr('basicInfoTipoDoc', 'DNI', formToUpdate)
        }
      }
    }
  };

  const getRandomInt = (max) => {
    return Math.floor(Math.random() * Math.floor(max));
  };

  function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some((field) => fieldsError[field]);
  }

  const submitForm = (requestId = "") => {
    sendFormPromise(match.params.id, requestId).then((response) => {
      if (response.code === "OK") {
        let formSend = { ...apiForm, status: "SENT" };
        setApiForm(formSend);
      } else {
        let errores = sentErrors+1
        setSentErrors(errores)

        notification["error"]({
          message: t("messages.aml.notifications.anErrorOcurred"),
          description: errores === 1 ? 'Error Interno: Actualice y reintente.' : 'Comuníquese con soporte.aml@gesintel.cl'
        });
        setApiForm(response.form);
      }
    });
  };

  const sendDocument = (requestId = "") => {
    if (requestId === "") {
      Modal.confirm({
        title: t("messages.aml.wantSubmitForm"),
        content: t("messages.aml.pressSend"),
        okText: t("messages.aml.send"),
        cancelText: t("messages.aml.cancel"),
        onOk() {
          submitForm(requestId);
        },
      });
    } else {
      submitForm(requestId);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFieldsValue({[attch.attchFileName.id]: undefined})
    setIsValidate(true);
    setValidarRegistros(true);

    validateFields(Object.keys(basicInformation));
    validateFields([infoPep.infoPepHasFamily.id, infoPep.infoPepIsPublic.id])

    if(apiForm.typeSol === "PJ") {
      if (infoActEco.infoActEcoRecords.val.length === 0) {
        validateFields(Object.keys(prodAct));
        registersStop = { ...registersStop, prodAct: true };
      }
      validateFields([accionistas.accionistasIsAccionista.id]);
      if(accionistas.accionistasIsAccionista.val && accionistas.accionistasAccionistaRecords.val.length === 0){
        validateFields(Object.keys(accionistaObj));
        registersStop = { ...registersStop, accionistasAccionistaRecords: true };
      }
    }

    if (tmpFilesList.length === 0) {
      validateFields(Object.keys(attch));
      registersStop = { ...registersStop, attch: true };
    }

    
    if(infoPep.infoPepHasFamily.val && infoPep.infoPepFamilyRecords.val.length === 0){
      validateFields(Object.keys(pepFamilyObj))
      registersStop = { ...registersStop, infoPepFamilyRecords: true };
    }

    if(infoPep.infoPepIsPublic.val && infoPep.infoPepPublicRecords.val.length === 0){
      validateFields(Object.keys(pepPublicObj))
      registersStop = { ...registersStop, infoPepPublicRecords: true };
    }

    validateFields(Object.keys(infoActEco));
    if (
      hasErrors(getFieldsError()) ||
      Object.values(registersStop).find((value) => value === true) !== undefined
    ) {
      notification["warning"]({
        message: t("messages.aml.missingRequiredField"),
      });
    } else {
      setOpenSigner(true)

      if(tmpFilesList !== null && tmpFilesList.length > 0){
        const formData = new FormData()
        tmpFilesList.forEach((file, index) => {
          formData.append('file', file)
          formData.append('fileName', fileNames[index])
        })
        formData.append('formId', apiForm.id);

        await sendFileFormPromise(formData);
      }

      if(hasSign) {
        let record = apiForm.recipient.record
        let _emails = ["no@email.com"];
        if(record.email != null) {
          _emails = record.email.split(",");
        }
        var _email = _emails[0].trim();
        let signParams = await signCDIFormPromise(apiForm.id, _email)
        if(signParams.embedUrl == "signed") {
          notification["warning"]({
            message: "Ya esta firmado"
          })
          setSigned(true)
          sendDocument(signParams.requestId)
        }else {
          if(signParams.clientId != "") {
            const client = new HelloSign({
              clientId: signParams.clientId
            });
            let testMode = !apiConfig.url.startsWith('https://api.amlupdate')
            client.open(signParams.embedUrl, {
              testMode
            });
            client.on('sign', () => {
              setSigned(true)
              sendDocument(signParams.requestId)
            });
          }else {
            notification["error"]({
              message: "Error al iniciar servicio de Firma Electronica",
              description: signParams.message
            })
          }
        }
      }else {
        sendDocument()
      }
      setOpenSigner(false)
    }
  };

  const renderFormItem = (formItem) => {
    return (
        <Col
          className={formItem.colClassName}
          span={formItem.wrapperCols}
          offset={formItem.offset}
        >
          <Form.Item
            className={formItem.itemClassName}
            label={formItem.label}
            labelCol={formItem.labelCol > 0 ? { span: formItem.labelCol } : {}}
            wrapperCol={
              formItem.labelCol > 0 ? { span: formItem.wrapperCol } : {}
            }
          >
            {getFieldDecorator(formItem.name, {
              rules: formItem.rules,
              initialValue: formItem.initialValue,
              validateTrigger: "onChange",
            })(formItem.item)}
          </Form.Item>
        </Col>
    );
  };

  const errorMsgSection3 = {
    pepPublicObj: "Campos requeridos en Pregunta 1, Sección IV.",
    pepFamilyObj: "Campos requeridos en Pregunta 2, Sección IV.",
    accionistaObj: "Campos requeridos en Sección III - Accionistas."
  }

  const renderFormItemTable = ({ section, cols=format === 'html' ? 6 : 8, offset, labelCol=0, wrapperCol=0, options=[], validator=null, customRule=null, handlerOnChangeObj=handleOnChangeField, customTitle, colsOption }) => {
    const type = section.type ? section.type : 'input'
    const required = "required" in section ? section.required : true
    const disabled = "disabled" in section ? section.disabled : false
    const initialValue = section.val && section.val !== '' && format === 'html' && type === 'date' ? moment(section.val, "DD/MM/YYYY") : section.val
    const pdfDisplayValue = () => {
      if (type === 'select' && options && options.length) {
        if (Array.isArray(section.val)) {
          return section.val
            .map((v) => { const opt = options.find((o) => o.val === v); return opt ? opt.text : v })
            .join(', ')
        }
        const opt = options.find((o) => o.val === section.val)
        return opt ? opt.text : section.val
      }
      return section.val
    }
    return renderFormItem({
      label: customTitle ? customTitle : section.title,
      name: section.id,
      initialValue: initialValue,
      colClassName: "topLabel",
      labelCol: labelCol,
      wrapperCol: wrapperCol,
      rules:
      [
        { required: required, message: t( "messages.aml.requestedField")},
        ...validator ? [{ validator: validator }]:[],
        ...type==='input' ? [validateLengthFieldWithInnerLength(section)]:[],
        ...customRule ? [customRule]:[]
      ],
      wrapperCols: cols,
      offset: offset,
      item: (
        format === 'html' || type === 'check' ?
          type === 'input' ?
            <Input
              placeholder="Ingrese texto"
              autoComplete="off"
              onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
              onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
              readOnly = {section.readOnly}
              onChange={(e) => handlerOnChangeObj( section.id, e.target.value ) }
              disabled={disabled}
            />
          : type === 'number' ?
            <InputNumber
              placeholder="Ingrese un número"
              autoComplete="off"
              onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
              onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
              min= {section.min}
              max={section.max}
              formatter = { section.isCurrency ? (value => `$ ${value}`)  : section.isPercentage ? (value => `${value}%`) : null}
              readOnly = {section.readOnly}
              onChange={(value) => {
              handlerOnChangeObj( section.id, value )
              }}
              disabled={disabled}
            />
          : type === 'textarea' ?
            <Input.TextArea
              placeholder="Ingrese texto"
              autoComplete="off"
              onFocus= {(e)=>handleReadOnly(e.target.id,false,section.id)}
              onBlur= {(e)=>handleReadOnly(e.target.id,true,section.id)}
              readOnly = {section.readOnly}
              onChange={(e) => handlerOnChangeObj( section.id, e.target.value ) }
              disabled={disabled}
              style = {{width: '100%'}}
            />
          : type === 'select' ?
            <Select
              allowClear
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder={section.multiple ? "Seleccione una o más opciones" : "Seleccione una opción"}
              onChange={(value, codigo) => handlerOnChangeObj(section.id, value, null, codigo)}
              disabled={disabled}
              style={{ width: '100%' }}
              mode = {section.multiple ? 'multiple' : ''}
            >
              { options.map((option) => (<Select.Option value={option.val} key={option.key} code={option.code}>{ option.text }</Select.Option>)) }
            </Select>
          : type === 'date' ?
            <DatePicker
              onFocus= {(e)=>handleReadOnly(e.currentTarget.id,false,section.id)}
              onBlur= {(e)=>handleReadOnly(e.currentTarget.id,true,section.id)}
              readOnly = {section.readOnly}
              format={"DD/MM/YYYY"}
              placeholder={"Ingrese la fecha"}
              style = {{width: '100%'}}
              disabled={disabled}
              mode={type}
              onChange={(momentObj, str) => {
                handlerOnChangeObj( section.id, momentObj ? moment(momentObj).format( "DD/MM/YYYY" ) : null )
              }}
            />
          : type === 'check' ?
            <Checkbox.Group
              style={{width: '100%'}}
              className={section.title && section.title !== '' ? 'has-title' : ''}
              onChange={(value) => handlerOnChangeObj(section.id, value) }
              >
                <hr/>
              {options.map((option) => (
                <Col span={colsOption ? colsOption : section.colsOption}>
                  <Checkbox value={option.val}>
                    { option.text }
                  </Checkbox>
                </Col>
              ))}
            </Checkbox.Group>
          :<Input/>
        :
          <div className="pdf-field-value">
            {pdfDisplayValue()}
          </div>
      ),
    })
  }

  const renderFormItemObj = (params) => {
    return renderFormItemTable({...params, handlerOnChangeObj: handlerOnChangeObjAttr})
  }

  const handleOnAddAttrTable = (attr, attrObj, attrTable) => {
    setIsValidate(true);
    const [stateObject,stateObjectSetter] = customState(attr)
    validateFields(Object.keys(stateObject)).then((error, values) => {
      const tableOk = Object.keys(stateObject).reduce(
        (acc, e) => {
          const field = stateObject[e];
          if (field.typeEntity && apiForm.typeSol && !field.typeEntity.includes(apiForm.typeSol)) {
            return acc;
          }
          return {
            ...acc,
            [field.key]: field.val,
          };
        },
        {}
      );
      const [stateObject1,stateObject1Setter] = customState(attrObj)
      let obj = { ...stateObject1 }
      let attr2 = Object.entries(obj).filter(([k,v]) => {
        return v.key === attrTable
      })[0]
      obj[attr2[1].id].val.push(tableOk)
      stateObject1Setter(obj)

      let formToUpdate = { ...apiForm }
      saveFormOnbPromiseLocal(formToUpdate).then(ret => {
        if(ret.success){
          handleOnClear(attr)
        }
      });

      registersStop[attr] = false;
    }).catch(error => notification.error({message: errorMsgSection3[attr]}));
  };

  // attrObj (obj con los campos)
  // attTable ()
  // index
  const handleDeleteAttrTable = (attrObj, attrTable, index) => {
    return () => {
      const [stateObject,stateObjectSetter] = customState(attrObj)
      let obj = { ...stateObject }
      let attr2 = Object.entries(obj).filter(([k,v]) => {
        return v.key === attrTable
      })[0]

      let xx = [...obj[attr2[1].id].val];
      xx.splice(index, 1);
      obj[attr2[1].id].val = xx
      stateObjectSetter(obj)

      let formToUpdate = { ...apiForm };
      formToUpdate.json[attrObj][attrTable] = xx
      saveFormOnbPromiseLocal(formToUpdate);
    };
  };

  const prodActColums = [
    {
      title: "Actividad Económica",
      dataIndex: "linea",
      width: "70%",
      render: (linea) => {
        const parts = (linea || "").split("|")
        return parts.slice(1).join("|").trim()
      }
    },
    {
      title: "Código de actividad",
      dataIndex: "linea",
      width: "22%",
      render: (linea) => {
        return (linea || "").split("|")[0].trim()
      }
    },
    format === "html" && !signed ? {
          title: "Acción",
          dataIndex: "",
          key: "x",
          width: "8%",
          render: (text, record, index) => (
            <a onClick={handleDeleteAttrTable('infoActEco', 'actRecords', index)}>
              <Icon type="delete" />
            </a>
          ),
        }
      : {},
  ];

  const accionistaColumns = [
    {
      title: "Tipo de Persona",
      dataIndex: "tipoPersona",
    },
    {
      title: "Nombre / Razón Social",
      dataIndex: "name",
    },
    {
      title: "Nro. de identificación",
      dataIndex: "nroIdentificacion",
    },
    {
      title: "Nacionalidad",
      dataIndex: "nacionalidad",
    },
    {
      title: "Participación (En %)",
      dataIndex: "participacion",
    },
    format === "html" && !signed ? {
      title: "Acción",
      dataIndex: "",
      width: "8%",
      render: (text, record, index) => (
        <a onClick={handleDeleteAttrTable('accionistas', 'accionistaRecords', index)}>
          <Icon type="delete" />
        </a>
      ),
    } : {},
  ];

  const getPepPublicColumns = () => {
    var columns = []
    if(apiForm.typeSol === 'PN') {
      columns.push(
        {
          title: "Cargo",
          dataIndex: "cargo",
          width:"23%"
        },
        {
          title: "Organismo Público",
          dataIndex: "orgPublic",
          width:"23%"
        },
        {
          title: "País",
          dataIndex: "pais",
          width:"23%"
        },
        {
          title: "Fecha de término",
          dataIndex: "fecTermino",
          width:"23%"
        },
      )
    }else{
    columns.push(
    {
      title: "Grupo de la persona relacionada",
      dataIndex: "grupo",
      width:"18.4%"
    },
    {
      title: "Nombre Completo",
      dataIndex: "name",
      width:"18.4%"
    },
    {
      title: "Nro. identificación",
      dataIndex: "nroIdentificacion",
      width:"18.4%"
    },
    {
      title: "Organismo Público",
      dataIndex: "orgPublic",
      width:"18.4%"
    },
    {
      title: "Cargo",
      dataIndex: "cargo",
      width:"18.4%"
    },
    )}

    if(format === "html" && !signed) {
      columns.push({
          title: "Acción",
          dataIndex: "",
          key: "x",
          width: "8%",
          render: (text, record, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={handleDeleteAttrTable('infoPep', 'publicRecords', index)}>
              <Icon type="delete" />
            </a>
          ),
        }
      )
    }
    return columns
  }

  const getPepFamilyColumns = () => {
    var columns = []
      if(apiForm.typeSol === 'PJ') {
        columns.push(
          {
            title: "Grupo de la persona",
            dataIndex: "grupo",
          },
          {
            title: "Nombre Completo Relacionado",
            dataIndex: "name",
          },
          {
            title: "Nro. identificación Relacionado",
            dataIndex: "nroId",
          },
          {
            title: "Nombre Completo Pariente",
            dataIndex: "nombrePariente",
          },
          {
            title: "Nro. identificación Pariente",
            dataIndex: "nroIdPariente"
          },
        )
      }else{
        columns.push(
          {
            title: "Nombre del Familiar",
            dataIndex: "name",
          },
          {
            title: "Nro. identificación",
            dataIndex: "nroId",
          },
          {
            title: "Cargo",
            dataIndex: "cargo"
          },
          {
            title: "Organismo público",
            dataIndex: "orgPublic",
          },
    )}

    if(format === "html" && !signed) {
      columns.push({
          title: "Acción",
          dataIndex: "",
          key: "x",
          width: "8%",
          render: (text, record, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={handleDeleteAttrTable('infoPep', 'familyRecords', index)}>
              <Icon type="delete" />
            </a>
          ),
        }
      )
    }
    return columns
  }

  const dniValidatorPeru = (rule, value, cb) => {
    if (value && !validateRucHelper(value)) {
      cb("Documento no válido");
    }
    cb();
  };

  const dniValidatorCompanyPeru = (rule, value, cb) => {
    if (value && !validateRucEntityHelper(value)) {
      cb("Documento no válido");
    }
    cb();
  };

  const numTelValidator = (rule, value, callback) => {
    const regex = /^[0-9]*$/;
    if (value && (value.length < 6 || value.length > 9)) {
      callback("Número debe entre 6 y 9 dígitos");
    } else if (value && !(regex.test(value))){
      callback("Debe contenter sólo números");
    } else {
      callback();
    }
  };

  const numCelValidator = (rule, value, callback) => {
    const regex = /^[0-9]*$/;
    if (value && value.length !== 9) {
      callback("Número debe tener 9 dígitos");
    } else if (value && !(regex.test(value))){
      callback("Debe contenter sólo números");
    } else {
      callback();
    }
  };

  const emailValidator = (rule, value, callback) => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (value && regex.test(value) === false){
      callback("Debe ingresar un correo electrónico válido");
    }else{
      callback();
    }
  }

  const docValidator = (tipoDoc) => {
    if (tipoDoc === "DNI") {
      return dniValidatorPeru;
    } else if (tipoDoc === "RUC") {
      return dniValidatorCompanyPeru;
    }
    return null;
  };

  return (
    <FormLayout view={match.params.view} >
      <div style={{ position: "relative" }}>
        {isLoading ? (
          <div className="form-header">
            <Row>
              <Col xs={9}></Col>
              <Col xs={6}>
                <div className="form-wrapper" style={{ textAlign: "center" }}>
                  <Spin style={{ fontColor: "#fff" }} size={"large"} />
                </div>
              </Col>
              <Col xs={9}></Col>
            </Row>
          </div>
        ) : (
          <>
            {apiForm !== null ? (
              <div
                className={
                  "form-content-kyc " + format + " " +(!isValidate ? " form-validate-messages" : "")
                }
              >
                <Form onSubmit={handleSubmit} className="form-form">
                  <Row
                    className="title-logo"
                    gutter={[0, 6]}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.9)",
                      marginTop: "0px",
                      marginBottom: "0px",
                      textAlign: "left",
                      paddingTop: "10px",
                      paddingLeft: "10px",
                    }}
                  >
                    <Col
                      xs={24 - colLogo}
                      sm={24 - colLogo}
                      md={24 - colLogo}
                      lg={24 - colLogo}
                      xl={24 - colLogo}
                    >
                      <h3> {apiForm.typeSol === 'PN' ? "FORMULARIO ONBOARDING - PERSONA NATURAL":"FORMULARIO ONBOARDING - PERSONA JURÍDICA"}</h3>
                    </Col>
                    <Col
                      className="logo-col"
                      xs={colLogo}
                      sm={colLogo}
                      md={colLogo}
                      lg={colLogo}
                      xl={colLogo}
                    >
                      <Logo currentUser={{ userId: user.id, subclienteId: '0' }} isForm={true} />
                    </Col>
                  </Row>
                  <Row
                    className="date"
                    gutter={[0, 6]}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.9)",
                      marginTop: "0px",
                      marginBottom: "0px",
                      textAlign: "left",
                      paddingBottom: "15px",
                      paddingLeft: "10px",
                    }}
                  >
                    <Col span={2} style={{ textAlign: "left" }}>
                      Fecha:
                    </Col>
                    <Col span={4}>
                      <div
                        className="formDate"
                        style={{
                          marginLeft: "5px",
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderColor: "#e8e8e8",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {date}
                      </div>
                    </Col>
                    <Col span={13} style={{ textAlign: "right" }}>
                      Folio:
                    </Col>
                    <Col span={5}>
                      <div
                        className="formDate"
                        style={{
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderColor: "#e8e8e8",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                          marginLeft: "8px",
                        }}
                      >
                        {apiForm.folio !== null ? apiForm.folio : ""}
                      </div>
                    </Col>
                    <Col span={19} style={{ textAlign: "right" }}>
                      Proceso:
                    </Col>
                    <Col span={5}>
                      <div
                        className="formDate"
                        style={{
                          borderStyle: "solid",
                          borderWidth: "1px",
                          borderColor: "#e8e8e8",
                          display: "flex",
                          justifyContent: "center",
                          marginRight: "10px",
                          marginLeft: "8px",
                        }}
                      >
                        {apiForm.proceso === 'CREATE' ? 'Creación' : 'Actualización'}
                      </div>
                    </Col>
                  </Row>
                  {apiForm.status === "SENT" &&
                  (format === "html") ? (
                    <>
                      <br />
                      <h3 style={{ textAlign: "center" }}>
                        Estimado(a){/* {apiForm.recipient.record.nombre} */}
                        {apiForm.recipient.record.name}, le informamos que su declaración fue correctamente
                        completada, agradecemos su tiempo y disposición.
                        <br />
                        Hemos enviado una copia de la declaración realizada al
                        correo electrónico registrado:<br/><br/>
                        {apiForm.recipient.record.email}
                      </h3>
                    </>
                  ) : (
                    <>
                      <Col className="summary" style={{textAlign: "justify", marginRight: 10}}>
                        <p>
                          En cumplimiento con lo establecido por la Ley N°30424 (norma que regula la responsabilidad  
                          administrativa de las personas jurídicas en el proceso penal), Arauco Holding Perú S.A.C y filiales han   
                          adoptado un Modelo de Prevención de Delitos que tiene como objetivo evitar la comisión de delitos   
                          de corrupción, lavado de activos, entre otros. El presente formato es requerido para cumplir con las   
                          exigencias establecidas en la Ley mencionada y es parte de nuestro proceso del conocimiento   
                          diligente de las personas con las cuales nos relacionamos.
                        </p>
                        <p>
                          Agradecemos completar el formato, el cual tiene carácter de Declaración Jurada. Este debe ser revisado y firmado por un Representante Legal.
                        </p>
                      </Col>
                    { apiForm.typeSol !== undefined &&
                    <>
                      <Row
                        className="subheader"
                        style={{
                          marginTop: "0px",
                        }}
                      >
                        <Col xl={24}>
                        I. INFORMACIÓN GENERAL{" "}
                        </Col>
                      </Row>
                      <Row className="content">
                      <Row className="inner-row" gutter={[16, 8]}>
                          <Col className="subsection-title" xs={24}>
                            Identificación
                            <hr/>
                          </Col>
                          {renderFormItemObj({
                            section: basicInformation.basicInfoName,
                            customTitle: apiForm.typeSol === 'PN' ? "Nombre" : "Razón Social"
                          })}

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoTipoDoc,
                            options: peru.tipoDocEntityOptions.map(o => ({ val: o.val, text: o.text }))
                          })}

                          {apiForm.typeSol === 'PN' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoTipoDoc,
                            options: peru.tipoDocOptions.map(o => ({ val: o.val, text: o.text }))
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoNroDoc,
                          })}

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoTipoEmpresa,
                              options: [
                                { val: "Privada", text: "Privada" },
                                { val: "Pública", text: "Pública" },
                                { val: "Mixta", text: "Mixta" }
                              ]
                            })
                          }

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoNombreFantasia,
                            })
                          }
                          {renderFormItemObj({
                            section: basicInformation.basicInfoPropositoRel,
                            options: propositoRelOptions.filter(({ val }) => val !== 'Comodato'),
                          })}
                          {basicInformation.basicInfoPropositoRel.val === 'Otro' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoPropositoRelOtro,
                            })
                          }

                          {renderFormItemObj({
                              section: apiForm.typeSol === 'PN' ? basicInformation.basicInfoNationality : basicInformation.basicInfoPaisConst,
                              options:
                                paises.map(item => {
                                  return {val: item.country, text: item.country}
                              })
                            })
                          }

                          {apiForm.typeSol === 'PN' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoOcupacion,
                              options:[
                                { val: "Empleado dependiente", text: "Empleado dependiente" },
                                { val: "Independiente / Empresario", text: "Independiente / Empresario" },
                                { val: "Otro", text: "Otro" },
                              ]
                            })
                          }

                          {basicInformation.basicInfoOcupacion.val === 'Otro' && apiForm.typeSol === 'PN' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoOcupacionOtro,
                          })
                          }

                          {/* {apiForm.typeSol === 'PN' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoResindencia,
                            options: [
                              { val: "Si", text: "Si" },
                              { val: "No", text: "No" },
                            ]
                          })
                          } */}

                          {/* {basicInformation.basicInfoResindencia.val === 'Si' && apiForm.typeSol === 'PN' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoResindenciaPais,
                            options:
                              paises.map(item => {
                                return {val: item.country, text: item.country}
                              })
                            })
                          } */}

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoMtrz,
                            options: [
                              {val:"SI",text:"Si"},
                              {val:"NO",text:"No"},
                            ]
                          })
                          }
                        {basicInformation.basicInfoMtrz.val === "SI" && apiForm.typeSol === 'PJ' && (
                        <>
                          <Col className="subsection-title" span= {24}>
                            Información Casa Matriz
                            <hr/>
                          </Col>
                            {renderFormItemObj({
                                section: basicInformation.basicInfoMtrzName,
                              })
                            }

                            {renderFormItemObj({
                                section: basicInformation.basicInfoMtrzPais,
                                options:
                                paises.map(item => {
                                return {val: item.country, text: item.country}
                              })
                              })
                            }

                            {renderFormItemObj({
                                section: basicInformation.basicInfoMtrzCity,
                              })
                            }

                            {renderFormItemObj({
                                section: basicInformation.basicInfoMtrzDir,
                              })
                            }
                        </>
                        )}
                          <Col className="subsection-title" span= {24}>
                            Domicilio
                            <hr/>
                          </Col>

                          {/* FIELD PAIS */}
                          {renderFormItemTable({
                            section: basicInformation.basicInfoPais,
                            options: paises.map(item => {
                              return {val: item.country, text: item.country, code: item.iso2}
                            }),
                            handlerOnChangeObj: async (id, value, obj, item) => {
                                await handlerOnChangeObjAttr(id, value)
                                if (item && item.props && item.props.code === 'PE') {
                                  getRegionComunaPromise(item.props.code).then((response) => {
                                    setRegionesPais(response)
                                  })
                                  await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoPais.id, item.props.code)
                                }else{
                                  setRegionesPais([])
                                  await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoPais.id, item?.props?.code || null)
                                }
                                setDistritos([])
                                setProvincias([])
                                setFieldsValue({[basicInformation.basicInfoProvincia.id]: null})
                                setFieldsValue({[basicInformation.basicInfoDepartamento.id]: null})
                                setFieldsValue({[basicInformation.basicInfoDistrito.id]: null})
                                await handlerOnChangeObjAttr(basicInformation.basicInfoProvincia.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoDepartamento.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoDistrito.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDepartamento.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoProvincia.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDistrito.id, null)
                            }
                          })}
                          {/* FIELD DEPARTAMENTO */}
                          {renderFormItemTable({
                            section: regionesPais.length > 0 ? basicInformation.basicInfoDepartamento : {...basicInformation.basicInfoDepartamento, type: 'input', required: false} ,
                            options: regionesPais.map((item) => {
                              return {val: item.name, text: item.name, code: item.code}
                            }),
                            handlerOnChangeObj: async (id, value, obj, item) => {
                                await handlerOnChangeObjAttr(id, value)
                                if (item && item.props && item.props.code) {
                                  let prov = regionesPais.filter(e => e.code === item.props.code)
                                  if (prov && prov.length > 0){
                                    setProvincias(prov[0].provincias)
                                  }else{
                                    setProvincias([])
                                  }
                                  await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDepartamento.id, item.props.code)
                                }else {
                                  setProvincias([])
                                  await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDepartamento.id, null)
                                }
                                setDistritos([])
                                setFieldsValue({[basicInformation.basicInfoProvincia.id]: null})
                                setFieldsValue({[basicInformation.basicInfoDistrito.id]: null})
                                await handlerOnChangeObjAttr(basicInformation.basicInfoProvincia.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoDistrito.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoProvincia.id, null)
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDistrito.id, null)
                            }
                          })}
                          {/* FIELD PROVINCIA */}
                          {renderFormItemTable({
                            section: provincias.length > 0 ? basicInformation.basicInfoProvincia : {...basicInformation.basicInfoProvincia, type: 'input', required: false} ,
                            options: provincias.map((item) => {
                              return {val: item.name, text: camelizerHelper(item.name), code: item.code}
                            }),
                            handlerOnChangeObj: async (id, value, obj, item) => {
                              await handlerOnChangeObjAttr(id, value)
                              if (item && item.props && item.props.code) {
                                let dist = provincias.filter(e => e.code === item.props.code)
                                if (dist && dist.length > 0){
                                  setDistritos(dist[0].comunas)
                                }else{
                                  setDistritos([])
                                }
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoProvincia.id, item.props.code)
                              }else {
                                setDistritos([])
                                await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoProvincia.id, null)
                              }
                              setFieldsValue({[basicInformation.basicInfoDistrito.id]: null})
                              await handlerOnChangeObjAttr(basicInformation.basicInfoDistrito.id, null)
                              await handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDistrito.id, null)
                            }
                          })}
                          {/* FIELD DISTRITO */}
                          {renderFormItemTable({
                            section: distritos.length > 0 ? basicInformation.basicInfoDistrito : {...basicInformation.basicInfoDistrito, type: 'input', required: false} ,
                            options: distritos.map((item) => {
                              return {val: item.name, text: camelizerHelper(item.name), code: item.code}
                            }),
                            handlerOnChangeObj: async (id, value, obj, item) => {
                              await handlerOnChangeObjAttr(id, value)
                              if (item && item.props && item.props.code) {
                                handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDistrito.id, item.props.code)
                              }else {
                                handlerOnChangeObjAttr(basicInformation.basicInfoCodigoDistrito.id, null)
                              }
                            }
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoDir,
                          })}

                          <Col className="subsection-title" span= {24}>
                            Contacto Comercial
                            <hr/>
                          </Col>

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoContactName,
                            })
                          }

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                              section: basicInformation.basicInfoCargo,
                            })
                          }

                          {renderFormItemObj({
                            section: basicInformation.basicInfoMail,
                            validator: emailValidator
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoTel,
                            validator: numTelValidator
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoCel,
                            validator: numCelValidator
                          })}

                          <Col className="subsection-title" span= {24}>
                            Contacto de Facturación
                            <hr/>
                          </Col>

                          {renderFormItemObj({
                            section: basicInformation.basicInfoNomFacturacion,
                          })}

                          {apiForm.typeSol === 'PJ' &&
                            renderFormItemObj({
                            section: basicInformation.basicInfoCargoFacturacion,
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoMailFacturacion,
                            validator: emailValidator
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoTelFacturacion,
                            validator: numTelValidator
                          })}

                          {renderFormItemObj({
                            section: basicInformation.basicInfoCelFacturacion,
                            validator: numCelValidator
                          })}
                        </Row>
                    </Row>
                  <>
                    <Row className="subheader">
                      <Col xl={24}>
                        II. INFORMACIÓN SOBRE ACTIVIDAD ECONÓMICA Y ACTIVIDAD COMERCIAL
                      </Col>
                    </Row>
                    <Row gutter={[16, 8]}>
                      {/* ↓ CAMPO INICIO DE ACTIVIDADES ↓ */}
                      {renderFormItemTable({
                            section: infoActEco.infoActEcoInitAct,
                            handlerOnChangeObj: (id, value) => {
                            handlerOnChangeObjAttr(id, value);
                            if (value) {
                              var now = moment(new Date());
                              var end = moment(value, "DD/MM/YYYY");
                              var duration = moment.duration(now.diff(end));
                              var months = "" + Math.floor(duration.asMonths());
                              if (months < 0) {
                                months = "0";
                              }
                              setFieldsValue({ [infoActEco.infoActEcoExperienciaMercado.id]: months });
                              handlerOnChangeObjAttr(infoActEco.infoActEcoExperienciaMercado.id, months);
                            }
                          }
                        })
                      }
                      {/* ↓CAMPO ANIOS DE EXPERIENCIA↓ */}
                      {renderFormItemObj({
                          section: infoActEco.infoActEcoExperienciaMercado,
                        })
                      }
                      {renderFormItemObj({
                          section: infoActEco.infoActEcoCustomActivities,
                          cols: 12,
                          options: peru.prodActOptions.map(option => {
                            return {val: option.val, text: option.name}
                          })
                        })
                      }
                    </Row>
                    <div className="content">
                      {format === "html" && !signed && (
                        <>
                        <Row gutter={[16, 8]}>
                            {renderFormItemTable({
                              section: prodAct.prodActDescripcion,
                              cols: 19,
                              options: SIIActivities?.map(item => {
                                return {val: item.codigo+" | "+ item.descripcion, text: item.codigo+" - "+ item.descripcion}
                              }),
                            })}

                            {prodAct.prodActDescripcion.val === 'Otras actividades' &&
                              renderFormItemTable({
                              section: prodAct.prodActOtras,
                              cols: 5,
                            })}

                            <Col className="button-col" xl={2}>
                              <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTable('prodAct', 'infoActEco', 'actRecords')} icon="plus" > Añadir </Button>
                            </Col>
                            <Col className="button-col" xl={2}>
                              <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('prodAct')}> Limpiar </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                        {infoActEco.infoActEcoRecords.val.length > 0 ?
                          <Table columns={prodActColums} dataSource={infoActEco.infoActEcoRecords.val} size="middle" pagination={false} ></Table>
                          : infoActEco.infoActEcoRecords.val.length < 1 &&
                            validarRegistros && (
                              <Row>
                                <Col
                                  span={24}
                                  style= {{color: 'red'}}
                                  className="missing-registers ant-form-explain"
                                >
                                  {t("messages.aml.registersRequired")}
                                </Col>
                              </Row>
                          )}
                        
                    </div>
                  </>
                      {apiForm.typeSol === 'PJ' &&
                        <>
                          <Row className="subheader">
                            <Col xl={24}>III. ACCIONISTAS</Col>
                          </Row>
                          <Row className="summary">
                            <Col span={20}>
                              ¿La empresa cuenta con accionistas que posean una participación igual o mayor al 25% del capital social, aporte o participación? De ser así ingrese a las personas naturales o jurídicas que cumplen con dichas condiciones.
                            </Col>
                            {renderFormItem({
                              label: "",
                              colClassName: "switch-col",
                              itemClassName: "radio-item-flat",
                              name: accionistas.accionistasIsAccionista.id,
                              labelCol: 0,
                              wrapperCol: 0,
                              offset: 1,
                              initialValue: accionistas.accionistasIsAccionista.val,
                              rules: [
                                {
                                  required: true,
                                  message: t("messages.aml.dontForgetSelect"),
                                },
                              ],
                              wrapperCols: 3,
                              item: (
                                <Radio.Group
                                  onChange={({ target }) =>
                                    handlerOnChangeObjAttr(
                                      accionistas.accionistasIsAccionista.id,
                                      target.value
                                    )
                                  }
                                >
                                  <Radio style={radioStyle} value={true}>
                                    Sí
                                  </Radio>
                                  <Radio style={radioStyle} value={false}>
                                    No
                                  </Radio>
                                </Radio.Group>
                              ),
                            })}
                          </Row>
                          {accionistas.accionistasIsAccionista.val && (
                            <div className="content">
                              {format === "html" && !signed && (
                                <>
                                  <Row className="summary" gutter={[20]} type={format === 'html' ? 'flex' : null}>
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjTipoPersona,
                                      options:[
                                        {val: "Persona Natural", text:"Persona Natural"},
                                        {val: "Persona Jurídica", text:"Persona Jurídica"}
                                      ],
                                      cols: 6
                                    })}
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjName,
                                      cols: 6
                                    })}
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjTipoId,
                                      options: accionistaObj.accionistaObjTipoPersona.val === 'Persona Natural' ? peru.tipoDocOptions : peru.tipoDocEntityOptions,
                                      cols: 6
                                    })}
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjNroIdentificacion,
                                      validator: docValidator(accionistaObj.accionistaObjTipoId.val),
                                      cols: 6
                                    })}
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjNacionalidad,
                                      options: paises.map(item => ({val: item.country, text: item.country})),
                                      cols: 6
                                    })}
                                    {renderFormItemTable({
                                      section: accionistaObj.accionistaObjParticipacion,
                                      cols: 6
                                    })}
                                  </Row>
                                  <Row className="button-row">
                                    {accionistas.accionistasAccionistaRecords.val.length < 1 &&
                                      validarRegistros && (
                                        <Col
                                          span={24}
                                          style={{color: 'red'}}
                                          className="missing-registers ant-form-explain"
                                        >
                                          {t("messages.aml.registersRequired")}
                                        </Col>
                                    )}
                                    <Col className="addRelation" xl={3}>
                                      <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTable('accionistaObj', 'accionistas', 'accionistaRecords')} icon="plus" > Añadir </Button>
                                    </Col>
                                    <Col className="addRelation" xl={3}>
                                      <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('accionistaObj')}> Limpiar </Button>
                                    </Col>
                                  </Row>
                                </>
                              )}
                              {accionistas.accionistasAccionistaRecords.val.length > 0 && format === "html" ?
                                <Row className="summary">
                                  <Table columns={accionistaColumns} dataSource={accionistas.accionistasAccionistaRecords.val} size="middle" pagination={false} />
                                </Row>
                                :
                                toDescriptionsPdf(accionistas.accionistasAccionistaRecords.val, accionistaObj, apiForm.typeSol)
                              }
                            </div>
                          )}
                        </>
                      }

                      <Row className="subheader">
                        <Col xl={24}>
                          {apiForm.typeSol === 'PJ' ? 'IV.' : 'III.'} INFORMACIÓN DE PERSONA EXPUESTA POLÍTICAMENTE O PÚBLICAMENTE (PEP)
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          {apiForm.typeSol === 'PN' ?
                          <div>
                            Los PEP son personas naturales, nacionales o extranjeras, que cumplen o que en los últimos dos (2) años hayan cumplido funciones públicas destacadas o funciones prominentes en una organización internacional, sea en el territorio nacional o extranjero, y cuyas circunstancias financieras puedan ser objeto de un interés. Asimismo, se considera como PEP al colaborador directo de la máxima autoridad de la institución. Será considerado bajo la presente definición a aquellas personas que se encuentren postulando a cualquier cargo de función pública, sea este designado por voto popular o por cualquier otro medio. También serán considerados como PEP al cónyuge o conviviente, y familiares hasta segundo grado de consanguinidad y segundo grado de afinidad. Por ejemplo: jefes de estado, funcionarios públicos, políticos, funcionarios gubernamentales, altos ejecutivos de empresas estatales, candidatos, funcionarios de partidos políticos.<br/><br/>
                            Yo, declaro que:
                          </div>
                          :
                          <div>
                            <p>
                              Los PEP son personas naturales, nacionales o extranjeras, que cumplen o que en los últimos dos (2)
                              años hayan cumplido funciones públicas destacadas o funciones prominentes en una organización
                              internacional, sea en el territorio nacional o extranjero, y cuyas circunstancias financieras puedan
                              ser objeto de un interés. Asimismo, se considera como PEP al colaborador directo de la máxima
                              autoridad de la institución. Será considerado bajo la presente definición a aquellas personas que se
                              encuentren postulando a cualquier cargo de función pública, sea este designado por voto popular o por
                              cualquier otro medio. También serán considerados como PEP al cónyuge o conviviente, y familiares hasta
                              segundo grado de consanguinidad y segundo grado de afinidad. Por ejemplo: jefes de estado, funcionarios
                              públicos, políticos, funcionarios gubernamentales, altos ejecutivos de empresas estatales,
                              candidatos, funcionarios de partidos políticos.
                            </p>
                            Los cargos considerados dentro del Grupo relacionado, son los siguientes:
                            <ul>
                              <li>Representante Legal</li>
                              <li>Alta Gerencia</li>
                              <li>Accionista</li>
                              <li>Directores</li>
                            </ul>
                            En nombre de la empresa que represento y sus entidades relacionadas, declaro que:
                          </div>
                          }
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col span={20}>
                        {apiForm.typeSol === 'PN' ?
                          <div>
                            <u>PREGUNTA 1:</u> ¿Usted desempeña actualmente o ha desempeñado en los últimos 2 años, 
                            alguno de los cargos indicados en Funciones Públicas destacadas?
                          </div>
                          :
                          <div>
                            <u>PREGUNTA 1:</u> ¿Una o más personas consideradas dentro del grupo
                            relacionado, desempeñan actualmente o han desempeñado en los últimos 2
                            años, alguno de los cargos indicados en Funciones Públicas destacadas?
                          </div>
                        }
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item-flat",
                          name: infoPep.infoPepIsPublic.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 1,
                          initialValue: infoPep.infoPepIsPublic.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect"),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(
                                  "infoPepIsPublic",
                                  target.value
                                )
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                Sí
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                No
                              </Radio>
                            </Radio.Group>
                          ),
                        })
                        }
                      </Row>
                      {infoPep.infoPepIsPublic.val && (
                          <div className="content">
                            {format === "html" && !signed && (
                              <>
                                {apiForm.typeSol === 'PJ' ?
                                  <Row gutter={[16, 8]} style={{margin: 10}}>
                                    <Col className="subsection-title" span= {24}>
                                      Datos de la persona relacionada
                                      <hr/>
                                    </Col>
                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicGrupo,
                                      options:[
                                        {val: "Representante Legal", text: "Representante Legal"},
                                        {val: "Alta Gerencia", text: "Alta Gerencia"},
                                        {val: "Accionista", text: "Accionista"},
                                        {val: "Directores", text: "Directores"},
                                      ],
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicName,
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicTipoDoc,
                                      options: peru.tipoDocOptions.map(o => ({val: o.val, text: o.text})),
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicNroId,
                                      validator: docValidator(pepPublicObj.pepPublicTipoDoc.val),
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicOrgPublic,
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicPais,
                                      cols: 6,
                                      options:
                                      paises.map(item => {
                                        return {val: item.country, text: item.country}
                                      })
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicCargoPj,
                                      cols: 6
                                    })}

                                    {renderFormItemTable({
                                      section: pepPublicObj.pepPublicFecTermino,
                                      cols: 6
                                    })}
                                  </Row>

                                  :

                                  <Row gutter={[16, 8]} style={{margin: 10}}>
                                      {renderFormItemTable({
                                        section: pepPublicObj.pepPublicCargo,
                                        cols: 6
                                      })}

                                      {renderFormItemTable({
                                        section: pepPublicObj.pepPublicOrgPublic,
                                        cols: 6
                                      })}

                                      {renderFormItemTable({
                                        section: pepPublicObj.pepPublicPais,
                                        cols: 6,
                                        options:
                                        paises.map(item => {
                                          return {val: item.country, text: item.country}
                                        })
                                      })}

                                      {renderFormItemTable({
                                        section: pepPublicObj.pepPublicFecTermino,
                                        cols: 6
                                      })}
                                    </Row>
                                }
                                <Row className="button-row">
                                  {infoPep.infoPepPublicRecords.val.length < 1 &&
                                    validarRegistros && (
                                      <Col
                                        span={24}
                                        style= {{color: 'red'}}
                                        className="missing-registers ant-form-explain"
                                      >
                                        {t("messages.aml.registersRequired")}
                                      </Col>
                                    )}

                                  <Col className="addRelation" xl={3}>
                                    <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTable('pepPublicObj', 'infoPep', 'publicRecords')} icon="plus" > Añadir </Button>
                                  </Col>
                                  <Col className="addRelation" xl={3}>
                                    <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('pepPublicObj')}> Limpiar </Button>
                                  </Col>
                                </Row>
                              </>
                            )}

                            {infoPep.infoPepPublicRecords.val.length > 0 && format === "html" ?
                              <Table columns={getPepPublicColumns()} dataSource={infoPep.infoPepPublicRecords.val} size="middle" pagination={false} ></Table>
                              :
                              toDescriptionsPdf(infoPep.infoPepPublicRecords.val, pepPublicObj, apiForm.typeSol)
                            }
                          </div>
                      )}

                      <Row className="summary">
                        <Col span={20}>
                          {apiForm.typeSol === 'PN' ?
                            <div>
                              <u>PREGUNTA 2:</u> ¿Su cónyuge o pariente(s) hasta segundo grado de 
                              consanguinidad (abuelo(a), padre, madre, hijo(a), hermano(a), nieto(a)) o 
                              afinidad (abuelo(a) del cónyuge, nieto(a) del cónyuge, padres, hermano (a) 
                              del cónyuge (cuñados)) se desempeñan actualmente o se han desempeñado 
                              en los últimos 2 años, en alguno de los cargos indicados en Funciones Públicas destacadas?
                            </div>
                            :
                            <div>
                              <u>PREGUNTA 2:</u> ¿Una o más personas consideradas dentro del grupo
                              relacionado, son cónyuge(s) o pariente(s) hasta segundo grado de
                              consanguinidad (abuelo(a), padre, madre, hijo(a), hermano(a), nieto(a)) o
                              afinidad (abuelo(a) del cónyuge, nieto(a) del cónyuge, padres, hermano (a) del
                              cónyuge (cuñados)) de personas que se desempeñan actualmente o hayan desempeñado
                              en los últimos 2 años, en alguno de los cargos indicados en Funciones Públicas destacadas?
                            </div>
                          }
                        </Col>
                        {renderFormItem({
                          label: "",
                          colClassName: "switch-col",
                          itemClassName: "radio-item-flat",
                          name: infoPep.infoPepHasFamily.id,
                          labelCol: 0,
                          wrapperCol: 0,
                          offset: 1,
                          initialValue: infoPep.infoPepHasFamily.val,
                          rules: [
                            {
                              required: true,
                              message: t("messages.aml.dontForgetSelect"),
                            },
                          ],
                          wrapperCols: 3,
                          item: (
                            <Radio.Group
                              onChange={({ target }) =>
                                handlerOnChangeObjAttr(
                                  "infoPepHasFamily",
                                  target.value
                                )
                              }
                            >
                              <Radio style={radioStyle} value={true}>
                                Sí
                              </Radio>
                              <Radio style={radioStyle} value={false}>
                                No
                              </Radio>
                            </Radio.Group>
                          ),
                        })}
                      </Row>

                      {infoPep.infoPepHasFamily.val && (
                          <div className="content">
                            {format === "html" && !signed && (
                              <>
                              {apiForm.typeSol === 'PJ' ?
                                <Row gutter={[16, 8]} style={{margin: 10}}>
                                  <Col className="subsection-title" span= {24}>
                                      Datos de la persona relacionada
                                      <hr/>
                                  </Col>

                                    {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyGrupo,
                                    customTitle: "Grupo relacionado",
                                    options:[
                                      {val: "Representante Legal", text: "Representante Legal"},
                                      {val: "Alta Gerencia", text: "Alta Gerencia"},
                                      {val: "Accionista", text: "Accionista"},
                                      {val: "Directores", text: "Directores"},
                                    ],
                                    cols: 6
                                    })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyName,
                                    customTitle: "Nombre del Familiar",
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyTipoDoc,
                                    cols: 6,
                                    options: peru.tipoDocOptions.map(o => ({val: o.val, text: o.text}))
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyNroId,
                                    validator: docValidator(pepFamilyObj.pepFamilyTipoDoc.val),
                                    cols: 6
                                  })}

                                  <Col className="subsection-title" span= {24}>
                                      Datos del pariente que posee el cargo de PEP
                                      <hr/>
                                  </Col>

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyParentescoPariente,
                                    customTitle: "Tipo de Parentesco",
                                    cols: 6,
                                    options: peru.relationshipOptionsParauco,
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyNamePariente,
                                    customTitle: "Nombre Completo",
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyTipoDocPariente,
                                    cols: 6,
                                    options: peru.tipoDocOptions.map(o => ({val: o.val, text: o.text}))
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyNroIdPariente,
                                    validator: docValidator(pepFamilyObj.pepFamilyTipoDocPariente.val),
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyOrgPublic,
                                    cols: 6
                                  })}
                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyPais,
                                    cols: 6,
                                    options:
                                    paises.map(item => {
                                      return {val: item.country, text: item.country}
                                    })
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyCargoPariente,
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyFecTermino,
                                    cols: 6
                                  })}
                                </Row>
                              :
                              <Row gutter={[16, 8]} style={{margin: 10}}>
                                {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyParentesco,
                                    cols: 6,
                                    options: peru.relationshipOptionsParauco,
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyName,
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyTipoDoc,
                                    cols: 6,
                                    options: peru.tipoDocOptions.map(o => ({ val: o.val, text: o.text }))
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyNroId,
                                    validator: docValidator(pepFamilyObj.pepFamilyTipoDoc.val),
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyCargo,
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyOrgPublic,
                                    cols: 6
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyPais,
                                    cols: 6,
                                    options:
                                    paises.map(item => {
                                      return {val: item.country, text: item.country}
                                    })
                                  })}

                                  {renderFormItemTable({
                                    section: pepFamilyObj.pepFamilyFecTermino,
                                    cols: 6
                                  })}
                              </Row>
                              }

                                <Row className="button-row">
                                  {infoPep.infoPepFamilyRecords.val.length < 1 &&
                                    validarRegistros && (
                                      <Col
                                        span={24}
                                        style= {{color: 'red'}}
                                        className="missing-registers ant-form-explain"
                                      >
                                        {t("messages.aml.registersRequired")}
                                      </Col>
                                    )}

                                  <Col className="addRelation" xl={3}>
                                    <Button type="primary" htmlType="button" onClick={()=> handleOnAddAttrTable('pepFamilyObj', 'infoPep', 'familyRecords')} icon="plus" > Añadir </Button>
                                  </Col>
                                  <Col className="addRelation" xl={3}>
                                    <Button type="primary" htmlType="button" icon="delete" onClick={(e)=>handleOnClear('pepFamilyObj')}> Limpiar </Button>
                                  </Col>
                                </Row>
                              </>
                            )}

                            {infoPep.infoPepFamilyRecords.val.length > 0 && format === "html" ?
                              <Table columns={getPepFamilyColumns()} dataSource={infoPep.infoPepFamilyRecords.val} size="middle" pagination={false} ></Table>
                              :
                              toDescriptionsPdf(infoPep.infoPepFamilyRecords.val, pepFamilyObj, apiForm.typeSol)
                            }
                          </div>
                      )}

                      <Row className="summary">
                        <Col span={21}>
                          <strong>Funciones públicas destacadas:</strong>
                          <br/><br/>
                          <ol>
                            <li> Presidentes (jefes de estado o de gobierno), Presidente del Consejo de Ministros, ministros,
                              viceministros y secretarios generales del poder ejecutivo.</li>
                            <li> Gobernadores regionales y alcaldes o máxima autoridad de gobiernos regionales y locales,
                              vicegobernadores regionales, regidores y gerentes de los gobiernos regionales y locales.</li>
                            <li> Congresistas de la República/Parlamento/Poder Legislativo, miembros de la oficialía mayor del
                              Congreso.</li>
                            <li> Presidente del Poder Judicial y Presidente de la Corte Suprema de Justicia; jueces supremos,
                              jueces superiores (vocales), jueces especializados o mixtos, gerente general, secretario general
                              y cargos equivalentes en el fuero militar.</li>
                            <li> Fiscal de la Nación, fiscales supremos, fiscales adjuntos supremos, fiscales superiores,
                              fiscales adjuntos superiores y secretario general del Ministerio Público - Fiscalía de la
                              Nación.</li>
                            <li> Embajadores y cónsules.</li>
                            <li> Oficiales de más alto rango de las fuerzas armadas y de las fuerzas de seguridad pública.</li>
                            <li> Jefes o cargos similares y miembros de los órganos de dirección y control de empresas de
                              propiedad estatal.</li>
                            <li> Los funcionarios o empleados con categoría o función no inferior a la de director general o
                              nacional, de entidades de la administración pública nacional, centralizada o
                              descentralizada.</li>
                            <li> La máxima autoridad, secretarios generales y jefes de gabinete de organismos públicos
                              reguladores, supervisores, especializados y/o ejecutores.</li>
                            <li> La máxima autoridad, secretarios generales y jefes de gabinete de asesores de organismos
                              constitucionalmente autónomos.</li>
                            <li> Jefes de logística, o funcionarios o empleados públicos encargados de las contrataciones y
                              adquisiciones, en el marco de la normativa aplicable en materia de contrataciones con el
                              Estado.</li>
                            <li> Jefes, directores, directores adjuntos, miembros de la junta directiva o cargos similares
                              de organismos internacionales. Debe entenderse por organizaciones internacionales a
                              aquellas entidades establecidas mediante acuerdos políticos oficiales entre los
                              distintos Estados, los cuales tienen el estatus de tratados internacionales, su existencia
                              es reconocida por ley en sus propios Estados y que dichas organizaciones se puedan
                              diferenciar del país en donde se encuentren radicadas, tales como la Organización de
                              las Naciones Unidas, la Organización Mundial del Comercio, etc.</li>
                          </ol>
                          También se considera como personas expuestas políticamente a los colaboradores directos
                          de la máxima autoridad de la institución u organización que cuente con facultades de
                          decisión resolutiva, por lo tanto se excluye a los funcionarios de niveles intermedios o
                          inferiores.

                        </Col>
                      </Row>

                      <Row className="subheader">
                        <Col xl={24}>
                          {apiForm.typeSol === 'PJ' ? 'V.' : 'IV.'} DECLARACIONES COMPLEMENTARIAS EN TEMAS DE CUMPLIMIENTO
                        </Col>
                      </Row>
                      <div className="content">
                        <Row className="summary">
                          <Col>
                            {apiForm.typeSol === 'PN' ? (
                              <>
                                Bajo la gravedad de juramento, como persona natural declaro en mi propio nombre que:
                                <ol type="1">
                                  <li>Conozco y garantizo cumplir el modelo de prevención de delitos, Código de Conducta Empresarial
                                    de Arauco Holding Perú SAC y sus filiales, cuyos contenidos han sido publicados en la página web
                                    www.parauco.com.</li>
                                  <li>Mantendré controles y medidas preventivas adecuadas para evitar la comisión de los delitos
                                    referidos en la Ley N° 30.424 durante toda la vigencia de la relación comercial o contractual.</li>
                                  <li>Conozco la existencia de las leyes y reglamentos anti corrupción, lavado de activos,
                                    financiamiento del terrorismo, entre otros delitos en el Perú y su exigibilidad.</li>
                                  <li>Cumplo con la legislación aplicable a nuestro giro de negocio.</li>
                                  <li>Los recursos, los fondos, dinero, productos y activos destinados a la ejecución de las relaciones
                                    comerciales y contractuales con Arauco Holding Perú SAC y sus filiales son de procedencia lícita y
                                    están ligados al desarrollo normal de nuestras actividades, no provienen de ninguna actividad ilícita
                                    de las contempladas en el Código Penal de Perú, o en cualquier norma que lo sustituya, adicione o
                                    modifique.</li>
                                  <li>No me encuentro designado o mencionado en las listas internacionales vinculantes para Perú de
                                    conformidad con el derecho internacional (listas del Consejo de Seguridad de las Naciones Unidas) o
                                    en las listas de la OFAC y demás listas inhibitorias internacionales o locales o bases de datos
                                    públicas relacionadas con información sobre delitos de lavado de activos, financiación
                                    del terrorismo o sus delitos fuente.</li>
                                  <li>No he sido sancionado y no me encuentro en un proceso de investigación por los delitos
                                    de corrupción, lavado de activos, financiamiento del terrorismo y otros delitos comprendidos en la
                                    Ley 30424.</li>
                                  <li>Proporcionaremos a Arauco Holding Perú SAC y sus filiales o a sus auditores externos la
                                    información y documentación que estos puedan requerir a fin de verificar el cumplimiento de la
                                    legislación vigente en materia de prevención de actos de corrupción en el ámbito público y privado,
                                    lavado de activos y financiamiento del terrorismo, comprometiéndose a cooperar plenamente con el
                                    desarrollo de dicha verificación.</li>
                                  <li>En caso de existir cambios de las circunstancias descritas anteriormente, dicha situación
                                    se comunicará dentro de 24 horas al Encargado de Prevención al correo
                                    electrónico <a href="mailto:mpd@parauco.com">mpd@parauco.com</a>.</li>
                                </ol>
                                Conocemos, declaramos y aceptamos que:
                                <br/><br/>
                                Arauco Holding Perú SAC y sus filiales estarán facultadas para efectuar las verificaciones que
                                consideren pertinentes y están en la obligación legal de solicitar las aclaraciones que estimen
                                pertinentes en el evento en que se presenten circunstancias con base en las cuales pueda tener
                                dudas razonables sobre nuestras operaciones, así como del origen de nuestros activos, evento en el
                                cual suministraremos las aclaraciones que sean del caso
                                <ol type="i">
                                  <li>Las declaraciones y garantías que se disponen en este documento sobrevivirán a la celebración
                                    y suscripción de cualquier relación contractual o comercial con Arauco Holding Perú SAC y filiales,
                                    durante toda la vigencia de las mismas.</li>
                                  <li>En caso de incumplimiento, incongruencia o discrepancia respecto de las obligaciones
                                    y declaraciones incorporadas en el presente documento, Arauco Holding Perú SAC y filiales podrá
                                    dar por terminada, con justa causa, cualquier relación comercial o contractual que exista, sin
                                    derecho a indemnización alguna para las Sociedades.</li>
                                </ol>
                              </>
                            ) : (
                              <>
                                Bajo la gravedad de juramento, como persona natural y/o actuando en calidad de representante
                                legal de la empresa cuyos datos se incluyen en este formulario, según aplique, declaro en mi propio
                                nombre y en la sociedad que represento, su matriz, afiliadas, filiales, directores, administradores,
                                representantes legales, accionistas, asociados o socios que directa o indirectamente tengan el 25%
                                o más del capital social, aporte o participación, que:
                                <ol type="1">
                                  <li>Conocemos y garantizamos dar cumplimiento al modelo de prevención de delitos, Código
                                    de Conducta Empresarial de Arauco Holding Perú SAC y sus filiales, cuyos contenidos han
                                    sido publicados en la página web www.parauco.com.</li>
                                  <li>Conocemos la existencia de las leyes y reglamentos anti corrupción, lavado de
                                    activos, financiamiento del terrorismo, entre otros delitos en el Perú y su exigibilidad (Ley 30424 y
                                    sus modificatorias).</li>
                                  <li>Cumplimos con la legislación aplicable a nuestro giro de negocio.</li>
                                  <li>Es obligación del Cliente mantener controles y medidas preventivas adecuadas para evitar
                                    la comisión de los delitos referidos en la Ley N° 30424 durante toda la vigencia de la
                                    relación contractual.</li>
                                  <li>Nuestros recursos, los fondos, dinero, productos y activos destinados a la ejecución de
                                    las relaciones comerciales y contractuales con Arauco Holding Perú SAC y sus filiales son de
                                    procedencia lícita y están ligados al desarrollo normal de nuestras actividades, no provienen de
                                    ninguna actividad ilícita de las contempladas en el Código Penal de Perú, o en cualquier norma que
                                    lo sustituya, adicione o modifique.</li>
                                  <li>No nos encontramos designados o mencionados en las listas internacionales vinculantes para
                                    Perú de conformidad con el derecho internacional (listas del Consejo de Seguridad de las
                                    Naciones Unidas) o en las listas de la OFAC y demás listas inhibitorias internacionales o locales o
                                    bases de datos públicas relacionadas con información sobre delitos de lavado de activos,
                                    financiación del terrorismo o sus delitos fuente.</li>
                                  <li>No hemos sido sancionados y no nos encontramos en un proceso de investigación por los delitos
                                    de corrupción, lavado de activos, financiamiento del terrorismo y otros delitos comprendidos en la
                                    Ley 30424.</li>
                                  <li>Proporcionaremos a Arauco Holding Perú SAC y sus filiales o a sus auditores externos la
                                    información y documentación que estos puedan requerir a fin de verificar el cumplimiento de la
                                    legislación vigente en materia de prevención de actos de corrupción en el ámbito público y privado,
                                    lavado de activos y financiamiento del terrorismo, comprometiéndose a cooperar plenamente con el
                                    desarrollo de dicha verificación.</li>
                                  <li>En caso de existir cambios de las circunstancias descritas anteriormente, dicha situación
                                    se comunicará dentro de 24 horas al Encargado de Prevención al correo
                                    electrónico <a href="mailto:mpd@parauco.com">mpd@parauco.com</a>.</li>
                                </ol>
                                Conocemos, declaramos y aceptamos que:
                                <br/><br/>
                                Arauco Holding Perú SAC y sus filiales estarán facultadas para efectuar las verificaciones que
                                consideren pertinentes y están en la obligación legal de solicitar las aclaraciones que estimen
                                pertinentes en el evento en que se presenten circunstancias con base en las cuales pueda tener
                                dudas razonables sobre nuestras operaciones, así como del origen de nuestros activos, evento en el
                                cual suministraremos las aclaraciones que sean del caso
                                <ol type="i">
                                  <li>Las declaraciones y garantías que se disponen en este documento sobrevivirán a la celebración
                                    y suscripción de cualquier relación contractual o comercial con Arauco Holding Perú SAC y filiales,
                                    durante toda la vigencia de las mismas.</li>
                                  <li>En caso de incumplimiento, incongruencia o discrepancia respecto de las obligaciones
                                    y declaraciones incorporadas en el presente documento, Arauco Holding Perú SAC y filiales podrá
                                    dar por terminada, con justa causa, cualquier relación comercial o contractual que exista, sin
                                    derecho a indemnización alguna para las Sociedades.</li>
                                </ol>
                              </>
                            )}
                          </Col>
                        </Row>
                      </div>

                    {/* {apiForm.typeSol === 'PN' &&
                      <>
                        <Row className="subheader">
                          <Col xl={24}>
                            IV. DECLARACIÓN DE PREVENCIÓN DEL LAVADO DE ACTIVOS Y FINANCIACIÓN AL TERRORISMO
                          </Col>
                        </Row>
                        <div className="content">
                          <Row className="summary">
                            <Col xl={24}>
                            Declaro qué: <br/><br/>
                              <strong>1.</strong> Los recursos, fondos, dineros, productos y activos destinados a la ejecución de la relación
                                comercial y contractual con {clientName} y sus filiales, incluido los gastos incurridos para la
                                habilitación y puesta en marcha del local, pago de remuneraciones, asignaciones, premios para
                                trabajadores y cotizaciones previsionales no provienen de ninguna actividad sancionada por el
                                Código Penal Chileno u otras normas que establezcan delitos base de lavado de activos, de
                                jurisdicciones señaladas por el GAFI con deficiencias estratégicas en sus sistemas ALA/CFT o de los
                                países y jurisdicciones que tienen un régimen fiscal preferencial, según define el Servicio de
                                Impuestos Internos.<br/><br/>
                              <strong>2.</strong> Mis actividades comerciales no están vinculadas, directa ni indirectamente, con el lavado de
                                  activos o con alguno de sus delitos base, ni con el financiamiento del terrorismo.<br/><br/>
                              <strong>3.</strong> En el caso de que comercialice productos, éstos cumplen con los derechos de propiedad
                                intelectual e industrial y no se trata de copias hechas sin el consentimiento del titular del derecho,
                                o de la persona autorizada por él, en el país de producción y cumpliendo, además, cuando
                                proceda, con la normativa aduanera.<br/><br/>
                              <strong>4.</strong> No me encuentro incluido en ninguno de los listados de las Resoluciones del Consejo de
                                Seguridad de Naciones Unidas que sancionan el financiamiento del terrorismo y el financiamiento
                                de la proliferación de armas de destrucción masiva.<br/><br/>
                              <strong>5.</strong> No he sido condenado/a bajo la ley chilena o extranjera por los delitos de lavado de activos, o
                                alguno de sus delitos base, o por financiamiento del terrorismo.<br/><br/>
                              <strong>6.</strong> En el evento de tomar conocimiento de un cambio en las circunstancias descritas
                                anteriormente, dicha situación la comunicaré dentro de 24 horas al oficial de cumplimiento de
                                {clientName} y sus filiales, al email <a href="mailto:mpd@parauco.com"> mpd@parauco.com.</a>
                                <br/><br/>
                              <strong>7.</strong> Conozco y acepto que:<br/><br/>
                                <ol type="i">
                                  <li>
                                    {clientName} y sus filiales está facultada para efectuar las verificaciones que
                                    considere pertinentes y está en la obligación legal de solicitar las aclaraciones que estime
                                    adecuadas respecto de mis actividades comerciales y del origen de mis activos,
                                    información que me obligo a entregar oportunamente.
                                  </li>
                                  <li>
                                    Las declaraciones serán efectivas y veraces durante toda la vigencia de la relación
                                    contractual con {clientName} y sus filiales.
                                  </li>
                                  <li>
                                    En caso de incumplimiento, incongruencia o discrepancia respecto de las obligaciones y
                                    declaraciones incorporadas en el presente documento, {clientName} y sus filiales
                                    podrá dar por terminada, con justa causa, cualquier relación comercial o contractual que
                                    exista, y no tendré derecho a indemnización alguna.
                                  </li>
                                </ol>
                            </Col>
                          </Row>
                        </div>
                      </>
                    }

                {apiForm.typeSol === 'PJ' &&
                  <>
                      <Row className="subheader">
                        <Col xl={24}>IV. DECLARACIÓN SOBRE GESTIÓN DEL RIESGO & COMPLIANCE</Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          En nombre de mi representada y sus entidades relacionadas (las "Sociedades”), declaro que:
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>1. </strong>

                          Los recursos, fondos, dineros, productos y activos destinados a la ejecución de las relaciones
                          comerciales y contractuales con {clientName} y sus filiales, incluido los gastos incurridos
                          para la habilitación y puesta en marcha del local, pago de remuneraciones, asignaciones, premios
                          para trabajadores y cotizaciones previsionales, no provienen de ninguna actividad sancionada por
                          el Código Penal Chileno u otras normas que establezcan delitos base de lavado de activos, de
                          jurisdicciones señaladas por el GAFI con deficiencias estratégicas en sus sistemas ALA/CFT o de los
                          países y jurisdicciones que tienen un régimen fiscal preferencial, según define el Servicio de
                          Impuestos Internos.

                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>2. </strong>

                          Las actividades de las Sociedades no están vinculadas, directa ni indirectamente, con el lavado
                          de activos o con alguno de sus delitos base, ni con el financiamiento del terrorismo.

                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>3. </strong>

                          En el caso de que la sociedad comercialice productos, éstos cumplen con los derechos de
                          propiedad intelectual e industrial y no se trata de copias hechas sin el consentimiento del titular
                          del derecho, o de la persona autorizada por él, en el país de producción y cumpliendo, además,
                          cuando proceda, con la normativa aduanera.

                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>4. </strong>

                          El Controlador de las Sociedades, persona natural o jurídica, no está incluido en ninguno de los
                          listados de las Resoluciones del Consejo de Seguridad de Naciones Unidas que sancionan el
                          financiamiento del terrorismo y el financiamiento de la proliferación de armas de destrucción
                          masiva.

                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>5. </strong>

                          Ninguna de las personas naturales controladoras o ejecutivos principales de las sociedades ha
                          sido condenada bajo la ley chilena o extranjera por los delitos de lavado de activos, o alguno de
                          sus delitos base, o por financiamiento del terrorismo.

                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>6. </strong>
                          Ninguna de las Sociedades ha sido sancionada en los términos de la Ley 20.393 que establece
                          Responsabilidad Penal de las Personas Jurídicas
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>7. </strong>
                          En el evento de que las personas naturales controladoras de las Sociedades o los ejecutivos
                          principales de las Sociedades tomen conocimiento de un cambio en las circunstancias descritas
                          anteriormente, dicha situación se comunicará dentro de 24 horas al Oficial de Cumplimiento de
                          {clientName} y sus filiales, al email <a href="mailto:mpd@parauco.com">mpd@parauco.com</a>
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          <strong>8. </strong>
                            Conozco y acepto que: <br/>
                            <ol type="i">
                              <li>
                                {clientName} y sus filiales está facultada para efectuar las verificaciones que
                                considere pertinentes y está en la obligación legal de solicitar las aclaraciones que estime
                                adecuadas respecto a las operaciones de las Sociedades y del origen de sus activos,
                                información que nos obligamos a entregar oportunamente.
                              </li>
                              <li>
                                Las declaraciones serán efectivas y veraces durante toda la vigencia de la relación
                                contractual con {clientName} y sus filiales.
                              </li>
                              <li>
                                En caso de incumplimiento, incongruencia o discrepancia respecto de las obligaciones y
                                declaraciones incorporadas en el presente documento, {clientName} y sus filiales
                                podrá dar por terminada, con justa causa, cualquier relación comercial o contractual que
                                exista, sin derecho a indemnización alguna para las Sociedades.
                              </li>
                            </ol>
                        </Col>
                      </Row>
                  </>
                } */}
                      <Row className="subheader">
                        <Col xl={24}>
                          {apiForm.typeSol === 'PJ' ? 'VI.' : 'V.'} PROTECCIÓN DE DATOS PERSONALES
                        </Col>
                      </Row>
                      <Row className="summary">
                        <Col xl={24}>
                          ARAUCO MALLS PERÚ S.A.C. (en adelante, "AMP"), con RUC N° 20510641516, domiciliada en Av. José
                          Larco N° 1301, oficina 502 - 503, distrito de Miraflores, provincia y departamento de Lima, en
                          cumplimiento con lo estipulado en la Ley Nº 29733, Ley de Protección de Datos Personales y su
                          Reglamento, aprobado mediante Decreto Supremo Nº 003-2013-JUS, pone a su conocimiento que
                          con el registro y firma de este documento, autorizo expresamente a AMP, el tratamiento de los
                          datos personales consignados, para los fines descritos en el párrafo introductorio correspondiente
                          al cumplimiento de Ley N°30424 (norma que regula la responsabilidad administrativa de las
                          personas jurídicas). De acuerdo con el numeral 10 del artículo 14 de la Ley de Protección de Datos
                          Personales, la información que se trate para fines del sistema de prevención de lavado de activos y
                          financiamiento del terrorismo, el consentimiento no es requerido. La información que usted brinde
                          en este formulario será tratada en cumplimiento de los deberes de confidencialidad, seguridad de la
                          información y demás aplicables según la legislación de la materia. AMP ha adoptado las medidas de
                          seguridad legales, técnicas y organizativas necesarias para evitar la pérdida, mal uso, alteración,
                          acceso no autorizado y robo de los datos personales. AMP se compromete a no utilizar los datos
                          personales para un fin distinto, salvo autorización expresa del cliente.
                        </Col>
                      </Row>
                      <Row className="subheader">
                        <Col xl={24}>
                          {apiForm.typeSol === 'PJ' ? 'VII.' : 'VI.'} DOCUMENTOS ADJUNTOS
                        </Col>
                      </Row>
                      <Row className="summary" style={{marginBottom:20}}>
                        {apiForm.typeSol === 'PN' ? (
                          <>
                            A continuación, adjunte la <strong>ficha RUC (con fecha no mayor a un año)</strong>.
                            Puede adjuntar documentos en <strong>formato pdf, jpg, Word, Excel</strong> cuyo
                            peso no supere los <strong>2MB</strong> por archivo.
                          </>
                        ) : (
                          <>
                            A continuación, adjunte la <strong>ficha RUC (con fecha no mayor a un año)</strong>.
                            Recuerde que debe indicar el <strong>nombre del documento</strong> que adjuntará.
                            Puede adjuntar documentos en <strong>formato pdf, jpg, Word, Excel</strong> cuyo
                            peso no supere los <strong>2MB</strong> por archivo.
                          </>
                        )}
                      </Row>
                      { format === 'pdf' ?
                        <Row>
                          { apiForm?.files?.length > 0 ?
                            <List
                              size="small"
                              header="Documentos adjuntos"
                              itemLayout="horizontal"
                              dataSource={apiForm.files}
                              renderItem={item => (
                                <List.Item>
                                  <List.Item.Meta
                                      description={item.name}
                                  />
                                  <List.Item.Meta
                                    description={item.originalName}
                                  />
                                </List.Item>
                              )}
                            />
                            :
                            <div style={{textAlign: 'center'}}>
                              No se adjuntaron documentos como sustento.
                            </div>
                          }
                        </Row>
                        : format === 'html' &&
                        <>
                          <Row>
                              {renderFormItemTable({
                                section: attch.attchFileName,
                                cols: 8,
                                options: [
                                  {val: "Ficha RUC (con fecha no mayor a un año)", text: "Ficha RUC (con fecha no mayor a un año)"},
                                ]
                              })}

                              <Col span={6} offset={1}>
                                <Upload {...propsUpload}>
                                  <Button style={{marginTop:5}}  disabled={!attch.attchFileName.val || tmpFilesList.length > 9} >
                                    <Icon type="upload" /> Subir Archivo
                                  </Button>
                                </Upload>
                              </Col>
                          </Row>
                            {tmpFilesList.length < 1 && validarRegistros && (
                              <Col
                                span={24}
                                style={{paddingTop: 20}}
                                className="missing-registers ant-form-explain"
                              >
                                Se requieren al menos 1 archivo adjunto.
                              </Col>
                            )}
                          <Row>
                            <List
                              size="small"
                              header="Documentos adjuntos"
                              itemLayout="horizontal"
                              dataSource={tmpFilesList.map((file, index)=> {return {fileName: file.name, docName: fileNames[index], index: index}})}
                              renderItem={item => (
                                <List.Item
                                  actions={[<a onClick={() => handleListDeleted(item.index)}>Eliminar</a>]}
                                >
                                  <List.Item.Meta
                                      description={item.docName}
                                  />
                                  <List.Item.Meta
                                    description={item.fileName}
                                  />
                                </List.Item>
                              )}
                            />
                          </Row>
                        </>
                      }
                      {format === "html" &&
                      <>

                        {!signed &&
                          <Row className="button-row">
                            <Col className="submitTrabajador" xl={24}>
                              <Button type="primary" onClick={handleSubmit} disabled={openSigner} icon={openSigner ? 'loading' : 'file-protect'}>
                                { hasSign ? 'Firmar' : 'Enviar' }
                              </Button>
                            </Col>
                          </Row>
                        }
                      </>
                      }
                    </>
                    }
                    </>
                  )}
                </Form>
              </div>
            ) : (
              <h2 style={{ textAlign: "center" }}>Formulario no encontrado</h2>
            )}
          </>
        )}
      </div>
    </FormLayout>
  );
};

export default withRouter(Form.create()(FormKyc));
